import { Drawer, Grid2 } from "@mui/material";
import { useState, useEffect } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { useParams } from "react-router-dom";
import { IPettyCashManage } from "../../../_common/models/pettyCash/pettyCashManage.model";
import { StandardButton } from "../../../_components/button/primary.button";
import { DrawerHeader } from "../../../_components/drawer/header.drawer";
import { StandardTextValidator } from "../../../_components/textValidator/standardTextValidator";
import { toastr } from "../../../_components/toastr/toastr";
import { handleErrorResponse } from "../../../_helpers/handleResponse.helper";
import { pettyCashService } from "../../../_services/pettyCash.service";
import { DataTypeAutoComplete } from "../../../_components/autocomplete/dataType.autocomplete";
import { DataTypeEnum } from "../../../_common/enum/dataType.enum";
import { getDateString, getFormatedDate, getToday } from "../../../_helpers/dateTime.helper";


export const PettyCashManageDrawer = (params: { isOpen?: boolean, onSave(): void, onClose(): void }) => {
    const { id } = useParams<{ id: string }>();

    const resetData = (): IPettyCashManage => ({
        id: id ? Number(id) : 0,
        date: '',
        centreId: Number(centreId),
        userId: 0,
        description: '',
        amount: 0,
        isActive: true
    });

    const { centreId } = useParams<{ centreId: string }>();
    const [data, setData] = useState<IPettyCashManage>(resetData);
    const [isLoading, setIsLoading] = useState(false);
    const [saving, setIsSaving] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if (id != null)
            fetchData();
        else
            setData(resetData);
    }, [id]);

    useEffect(() => {
        if (isOpen == false)
            setIsOpen(true);
    }, []);

    function fetchData() {
        if (!id) return;

        setIsLoading(true);
        return pettyCashService
            .get(id)
            .then(
                (json: IPettyCashManage) => {
                    setData(json);
                }, handleErrorResponse
            )
            .finally(() => {
                setIsLoading(false);
            });
    }

    function submit(e: any) {
        e.preventDefault();
        setIsSaving(true);
        return pettyCashService
            .submit(data)
            .then(
                () => {
                    toastr.success("Saved successfully");
                    resetData();
                    params.onSave();
                }, handleErrorResponse
            )
            .finally(() => setIsSaving(false));
    }

    function disable() {
        if (!id) return;
        setIsLoading(true);
        return pettyCashService
            .disable(id)
            .then(
                () => {
                    toastr.success("Disabled successfully");
                    params.onSave();
                }, handleErrorResponse
            )
            .finally(() => setIsLoading(false));
    }

    function handleChange(event: any) {
        setData((_data: any) => ({ ..._data, [event.target.name]: event.target.value }));
    }

    return (
        <Drawer
            anchor={"right"}
            variant="persistent"
            open={isOpen}
            ModalProps={{
                keepMounted: true
            }}>

            <DrawerHeader name={(!!id) ? "Update PettyCash" : "Create PettyCash"} onClose={params.onClose} />

            <ValidatorForm
                onSubmit={submit}
                noValidate>

                <Grid2 container spacing={1} sx={{ "padding": "8px" }}>
                    <Grid2 size={{ xs: 12 }}>
                        <DataTypeAutoComplete
                            name="userId"
                            label="Staff"
                            required
                            value={data.userId}
                            onChange={handleChange} dataType={DataTypeEnum.Users} />
                    </Grid2>

                    <Grid2 size={{ xs: 12 }}>
                        <StandardTextValidator
                            key="description"
                            name="description"
                            label="Description"
                            required
                            fullWidth
                            validators={['required', 'minStringLength:1']}
                            errorMessages={['required field', "Field cannot be empty"]}
                            value={data.description}
                            onChange={handleChange}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 6 }}>
                        <StandardTextValidator
                            name="date"
                            label="Date"
                            required
                            inputProps={{ max: getDateString(getToday()) }}
                            fullWidth
                            type="date"
                            errorMessages={['required field', "Field cannot be empty"]}
                            value={getFormatedDate(data.date)}
                            onChange={handleChange}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 6 }}>
                        <StandardTextValidator
                            key="amount"
                            name="amount"
                            label="Amount"
                            required
                            fullWidth
                            validators={['required',]}
                            errorMessages={['required field']}
                            value={data.amount}
                            onChange={handleChange}
                        />
                    </Grid2>


                    <Grid2 size={{ xs: 12 }}>
                        <Grid2 container spacing={1}>
                            <Grid2 size={{ xs: !data.id ? 12 : data?.isActive === false ? 12 : 6 }}>
                                <StandardButton
                                    saving={saving}
                                    loading={isLoading}
                                    icon="save"
                                    type="submit">
                                    {(data?.isActive === false) ? "Save and Reactivate" : "Save"}
                                </StandardButton>
                            </Grid2>

                            {(!!id && data?.isActive === true) &&
                                <Grid2 size={{ xs: 6 }}>
                                    <StandardButton
                                        saving={saving}
                                        loading={isLoading}
                                        icon="block"
                                        variant="error"
                                        onClick={disable}>
                                        Disable
                                    </StandardButton>
                                </Grid2>
                            }
                        </Grid2>
                    </Grid2>
                </Grid2>

            </ValidatorForm>
        </Drawer>
    );
};